
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Courses from "../pages/courses/page";
import Testimonials from "../pages/testimonials/page";
import Treatment from "../pages/treatment/page";
import Contact from "../pages/contact/page";
import AdvisorCourse from '../pages/advisor-course/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/courses",
    element: <Courses />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "/treatment",
    element: <Treatment />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: '/advisor-course',
    element: <AdvisorCourse />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
